import { render, staticRenderFns } from "./DealServiceInfo.vue?vue&type=template&id=2ea73946&scoped=true&"
import script from "./DealServiceInfo.vue?vue&type=script&lang=js&"
export * from "./DealServiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./DealServiceInfo.vue?vue&type=style&index=0&id=2ea73946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea73946",
  null
  
)

export default component.exports